import BaseMask from "./_base.mask";

const HOUR_MASK = "99:99";

const validateHour = hour => {
  if (hour === "") {
    return true;
  }

  const regEx = /^[0-9]{2}:[0-9]{2}$/;
  if (!regEx.test(hour)) {
    return false;
  }

  if (parseInt(hour.substr(0, 2)) > 23) {
    return false;
  }

  if (parseInt(hour.substr(3, 5)) > 59) {
    return false;
  }

  return true;
};

export class HourMask extends BaseMask {
  static getType() {
    return "hour";
  }

  getValue(value, settings) {
    return this.getVMasker().toPattern(value, HOUR_MASK);
  }

  getRawValue(maskedValue, settings) {
    return super.removeNotNumbers(maskedValue);
  }

  validate(value, settings) {
    return validateHour(value);
  }
}
